enum IntegrationEnvType {
  PRODUCTION = "production",
  SANDBOX = "sandbox",
}

export default IntegrationEnvType;
